import { styled } from 'styled-components';

export const SocialFooterRoot = styled.div`
  background-color: #2c2f38;
  margin: 0 auto;
  padding: 5rem 24.7rem;
  width: 100%;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 5rem 2rem;
  }
`;

export const MenuRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 0 3rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    justify-content: center;
    margin: 1rem 0 2rem 0;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SocialMenu = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const SocialWrapper = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0 3rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    justify-content: center;
    margin: 0 0 2rem 0;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: flex-end;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex-direction: column;
    align-items: center;
    gap: 3rem;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2rem;
  max-width: 90rem;
  width: 100%;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    align-items: center;
    gap: 3rem;
  }
`;

export const SocialIcon = styled.i`
  font-size: 2.8rem;
  padding: 0.5rem;
  color: white;
  cursor: pointer;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.5rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`;
